import DashView from '@/components/Dash.vue'
import LoginView from '@/components/Login.vue'
import NotFoundView from '@/components/404.vue'

// Import Views - Dash
import DashboardView from '@/components/views/Dashboard.vue'
import BrandDashboardView from '@/components/views/BrandDashboard.vue'

// Account
import AccountTableView from '@/components/views/Account/AccountTable.vue'
import CreateAccountView from '@/components/views/Account/CrAccount.vue'
import UpdatedAccountView from '@/components/views/Account/UpAccount.vue'

// LineNotify
import LineNotifyTableView from '@/components/views/LineNotify/LineNotifyTable.vue'

// Member
import MemberTableView from '@/components/views/Member/MemberTable.vue'
import MemberOrderTableView from '@/components/views/Member/MemberOrderTable.vue'
import MemberIdentityTableView from '@/components/views/Member/MemberIdentityTable.vue'
import UpdatedMemberView from '@/components/views/Member/UpMember.vue'
import MemberInfoView from '@/components/views/Member/MemberInfo.vue'
import UpgradeMemberInfoView from '@/components/views/Member/UpgradeMemberInfo.vue'
import ShopperMonetTableView from '@/components/views/Member/ShopperMoneyTable.vue'
import oneShopperMoneyView from '@/components/views/Member/OneShopperMoney.vue'

// Platform
import PlatformTableView from '@/components/views/Platform/PlatformTable.vue'
import PlatformAdTableView from '@/components/views/Platform/AdTable.vue'
import PlatformCreateAdView from '@/components/views/Platform/CrAd.vue'
import PlatformUpdatedAdView from '@/components/views/Platform/UpAd.vue'
import MealTagTableView from '@/components/views/Platform/MealTagTable.vue'
import MealTagFormView from '@/components/views/Platform/MealTagForm.vue'
import TradeSetting from '@/components/views/TradeSetting.vue'

// Barnd
import BrandTableView from '@/components/views/Brand/BrandTable.vue'
import StoreTableView from '@/components/views/Brand/StoreTable.vue'
import GroupTableView from '@/components/views/Brand/GroupTable.vue'
import CreateBrandView from '@/components/views/Brand/CrBrand.vue'
import UpdatedBrandView from '@/components/views/Brand/UpBrand.vue'
import CreateStoreView from '@/components/views/Brand/CrStore.vue'
import CreateGroupView from '@/components/views/Brand/CrGroup.vue'
import UpdatedStoreView from '@/components/views/Brand/UpStore.vue'
import UpdatedGroupView from '@/components/views/Brand/UpGroup.vue'
import BrandInfoView from '@/components/views/Brand/BrandInfo.vue'
import StoreInfoView from '@/components/views/Brand/StoreInfo.vue'
import StoreGroup from '@/components/views/Brand/store-group.vue'
import ChangeStoresIconView from '@/components/views/Brand/ChangeStoresIcon.vue'
import AdTableView from '@/components/views/Brand/AdTable.vue'
import CreateAdView from '@/components/views/Brand/CrAd.vue'
import UpdatedAdView from '@/components/views/Brand/UpAd.vue'
import CopyAdView from '@/components/views/Brand/CopyAd.vue'
import BrandAdTableView from '@/components/views/Brand/BrandAdTable.vue'
import CreateBrandAdView from '@/components/views/Brand/CrBrandAd.vue'
import UpdatedBrandAdView from '@/components/views/Brand/UpBrandAd.vue'
import BatchSetupStore from '@/components/views/Brand/BatchSetupStore.vue'

// Order
import OrderTableView from '@/components/views/Order/OrderTable.vue'
import OrderExceptionTableView from '@/components/views/Order/OrderExceptionTable.vue'
import OrderInfoView from '@/components/views/Order/OrderInfo.vue'
import BlackListView from '@/components/views/Order/BlackListTable.vue'
import menuQuerystringView from '@/components/views/Order/menuquerystringview.vue'

// Menu
import MenuTableView from '@/components/views/Menu/MenuTable.vue'
import MenuDetailTableView from '@/components/views/Menu/MenuDetailTable.vue'
import MenuBuildView from '@/components/views/Menu/menu-build.vue'
import MenuInfoView from '@/components/views/Menu/MenuInfo.vue'
import MenuStepView from '@/components/views/Menu/menu-step.vue'
import CreateMenuView from '@/components/views/Menu/CrMenu.vue'
import CreateProductView from '@/components/views/Menu/CrMenuProduct.vue'
import CreateOptionView from '@/components/views/Menu/CrMenuOption.vue'
import CreateCombinationView from '@/components/views/Menu/CrCombination.vue'
import CreateJoinMenuView from '@/components/views/Menu/CrJoinMenu.vue'
import StoreMenuTable from '@/components/views/Menu/Temp/store-menu-table.vue'
import UpdatedMenuView from '@/components/views/Menu/UpMenu.vue'
import UpdatedProductView from '@/components/views/Menu/UpMenuProduct.vue'
import UpMenuAdjustView from '@/components/views/Menu/up-menu-adjust.vue'
import UpMenuOptionView from '@/components/views/Menu/up-menu-option.vue'
import UpdatedCategoryView from '@/components/views/Menu/UpMenuCategory.vue'
import UpdatedBlockView from '@/components/views/Menu/UpMenuBlock.vue'
import UpdatedPackageView from '@/components/views/Menu/UpMenuPackage.vue'
import UpdatedCombinationView from '@/components/views/Menu/UpCombination.vue'
import UpdatedCombinationPriceView from '@/components/views/Menu/UpCombinationPrice.vue'
import UpdatedJoinMenuView from '@/components/views/Menu/UpJoinMenu.vue'
import BindingPosView from '@/components/views/Menu/binding-pos.vue'
import CrBindingView from '@/components/views/Menu/CrBinding.vue'
import ProductImageView from '@/components/views/Menu/ProductImage.vue'
import ProductSettingView from '@/components/views/Menu/ProductSetting.vue'
import CrImgSettingView from '@/components/views/Menu/CrImgSetting.vue'
import CrProductSettingView from '@/components/views/Menu/CrProductSetting.vue'
import CrIconSettingView from '@/components/views/Menu/CrIconSetting.vue'
import CrStoreClassView from '@/components/views/Menu/CrStoreClass.vue'
import CopyStoreTemp from '@/components/views/Menu/Temp/CopyStoreTemp.vue'
import CupDiscountTableView from '@/components/views/Menu/CupDiscountTable.vue'

// Schedule
import SeheduleTableView from '@/components/views/Schedule/ScheduleTable.vue'
import StoreScheduleTableView from '@/components/views/Schedule/StoreScheduleTable.vue'
import BrandScheduleTableView from '@/components/views/Schedule/BrandScheduleTable.vue'
import UpScheduleView from '@/components/views/Schedule/UpSchedule.vue'
import CrScheduleView from '@/components/views/Schedule/CrSchedule.vue'

// History
import BrandHistoryTableView from '@/components/views/History/BrandHistoryTable.vue'
import StoreHistoryTableView from '@/components/views/History/StoreHistoryTable.vue'
import OneStoreHistoryTableView from '@/components/views/History/OneStoreHistoryTable.vue'
import OneDayHistoryTableView from '@/components/views/History/OneDayHistoryTable.vue'
import SearchHistoryView from '@/components/views/History/SearchHistory.vue'
import historyOrderInfoView from '@/components/views/History/HistoryOrderInfo.vue'

// Chart
import ChartDashView from '@/components/views/Chart/ChartDash.vue'
import WeekChartDashView from '@/components/views/Chart/WeekChartDash.vue'
import SearchMapView from '@/components/views/Chart/SearchMap.vue'
import CouponChartView from '@/components/views/Chart/CouponChart.vue'

// RealTime
import DisItemTableOldView from '@/components/views/RealTime/DisItemTableOld.vue'
import DisItemTableView from '@/components/views/RealTime/DisItemTable.vue'
import DisProductView from '@/components/views/RealTime/DisProdu.vue'
import MqttTableView from '@/components/views/RealTime/MqttTable.vue'
import MqttSearchView from '@/components/views/RealTime/MqttSearch.vue'
import TableSettingView from '@/components/views/RealTime/TableSetting.vue'
import PrinterTableView from '@/components/views/RealTime/PrinterTable.vue'
import PrinterInfoView from '@/components/views/RealTime/PrinterInfo.vue'
import CrPrinterView from '@/components/views/RealTime/CrPrinter.vue'
import UpPrinterView from '@/components/views/RealTime/UpPrinter.vue'
import CrPrinterStoreView from '@/components/views/RealTime/CrPrinterStore.vue'
import UpPrinterStoreView from '@/components/views/RealTime/UpPrinterStore.vue'
import PrinterStoreTableView from '@/components/views/RealTime/PrinterStoreTable.vue'
import DisScheduleItemTableView from '@/components/views/RealTime/DisScheduleItemTable.vue'
import LimitedScheduleItemTableView from '@/components/views/RealTime/LimitedScheduleItemTable.vue'
import CrDisabeScheduleView from '@/components/views/RealTime/CrDisableSchedule.vue'
import CopyLimiScheduleView from '@/components/views/RealTime/CopylimitedSchedule.vue'
import CrLimitScheduleView from '@/components/views/RealTime/CrlimitedSchedule.vue'
import DisItemTableBrand from '@/components/views/RealTime/DisItemTableBrand.vue'
import DisItemTableStore from '@/components/views/RealTime/DisItemTableStore.vue'

// Marketing
// import BrandMarketingTableView from '@/components/views/Marketing/MarketingTable.vue'
import MarketingScheduleTableView from '@/components/views/Marketing/MarketingScheduleTable.vue'
import CrActivityView from '@/components/views/Marketing/CrActivity.vue'
import ActivityInfoView from '@/components/views/Marketing/ActivityInfo.vue'
import ActivityDetailView from '@/components/views/Marketing/Temp/ActivityInfoTemp.vue'
import ActivityInfoFormView from '@/components/views/Marketing/ActivityInfoForm.vue'
import CouponListView from '@/components/views/Marketing/CouponTable.vue'
import UpCouponTableView from '@/components/views/Marketing/UpCouponTable.vue'
import OperatingChart from '@/components/views/Marketing/OperatingChart.vue'
import SystemUsage from '@/components/views/Marketing/SystemUsage.vue'

// Discount
import DiscountTableView from '@/components/views/Discount/DiscountTable.vue'
import ChooseDiscountView from '@/components/views/Discount/ChooseDiscount.vue'
import CrDiscountView from '@/components/views/Discount/CrDiscount.vue'
import UpDiscountTableView from '@/components/views/Discount/UpDiscountTable.vue'
import UpDiscountView from '@/components/views/Discount/UpDiscount.vue'
import DiscountInfoView from '@/components/views/Discount/DiscountInfo.vue'
import DiscountStoreView from '@/components/views/Discount/UpDiscountStore.vue'

// CashAccount
import CashAccountView from '@/components/views/CashAccount/CashAccountTable.vue'
import CashAccountErrorView from '@/components/views/CashAccount/CashAccountErrorTable.vue'
import CashAccountInfoView from '@/components/views/CashAccount/CashAccountInfo.vue'
import CashAccountSearchView from '@/components/views/CashAccount/AccountSearch.vue'

// Designated
import DesignatedTableView from '@/components/views/Designated/DesignatedTable.vue'
import CrDesignatedView from '@/components/views/Designated/CrDesignated.vue'
import UpDesignatedView from '@/components/views/Designated/UpDesignated.vue'

// Rating
import RatingTableView from '@/components/views/Rating/RatingTable.vue'

import announcement from '@/components/views/Announcement'
import announcementForm from '@/components/views/Announcement/components/AnnouncementForm.vue'

// Reconciliation
import VenderTradeTable from '@/components/views/VenderTradeTable'
import CommissionHistory from '@/components/views/VenderTradeTable/CommissionHistory.vue'
import CommissionStore from '@/components/views/VenderTradeTable/CommissionStore.vue'

// Modules
import brandToStoreMenu from '@/routes/modules/brand-to-store-menu.js'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView,
    requiresAuth: false
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'dashboard',
        meta: {
          title: '首頁',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'brandDashboard',
        alias: '',
        component: BrandDashboardView,
        name: 'brandDashboard',
        meta: {
          title: '首頁',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為帳號
        path: 'accountTable',
        component: AccountTableView,
        name: 'accountTable',
        meta: {
          title: '帳號管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crAccount',
        component: CreateAccountView,
        name: 'crAccount',
        meta: {
          title: '新增帳號',
          description: '',
          route: '帳號管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upAccount/:role_type/:manager_id',
        component: UpdatedAccountView,
        name: 'upAccount',
        meta: {
          title: '編輯帳號',
          description: '',
          route: '帳號管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為line通知
        path: 'lineNotifyTable',
        component: LineNotifyTableView,
        name: 'lineNotifyTable',
        meta: {
          title: 'LINE通知管理',
          description: '',
          route: '',
          requiresAuth: true
        }
      }, { // 以下為會員
        path: 'memberTable',
        component: MemberTableView,
        name: 'memberTable',
        meta: {
          title: '會員管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'memberOrderTable/:user_id',
        component: MemberOrderTableView,
        name: 'memberOrderTable',
        meta: {
          title: '會員線上訂單列表',
          description: '',
          route: '會員管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upMember/:user_id',
        component: UpdatedMemberView,
        name: 'upMember',
        meta: {
          title: '編輯會員',
          description: '',
          route: '會員管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'memberInfo/:user_id',
        component: MemberInfoView,
        name: 'memberInfo',
        meta: {
          title: '會員資訊',
          description: '',
          route: '會員管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upgradememberInfo/:user_id',
        component: UpgradeMemberInfoView,
        name: 'memberInfo',
        meta: {
          title: '整合帳號列表',
          description: '',
          route: '會員管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'memberIdentity/:shopper_id',
        component: MemberIdentityTableView,
        name: 'memberIdentity',
        meta: {
          title: '會員登入紀錄',
          description: '',
          route: '會員管理',
          requiresAuth: true
        }
      }, {
        path: 'shopperMoneyTable',
        component: ShopperMonetTableView,
        name: 'shopperMoneyTable',
        meta: {
          title: '會員消費列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'oneShopperMoney/:shopper_id',
        component: oneShopperMoneyView,
        name: 'oneShopperMoney',
        meta: {
          title: '會員消費紀錄',
          description: '',
          route: '會員消費管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為平台管理
        path: 'platformTable',
        component: PlatformTableView,
        name: 'platformTable',
        meta: {
          title: '平台管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'platformAdTable',
        component: PlatformAdTableView,
        name: 'platformAdTable',
        meta: {
          title: '平台廣告',
          description: '',
          route: '平台管理',
          requiresAuth: true,
          isShowInJkos: false,
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/brandAdTable.pdf'
        }
      }, {
        path: 'mealTagTable',
        component: MealTagTableView,
        name: 'mealTagTable',
        meta: {
          title: '餐點種類列表',
          description: '',
          route: '平台管理/餐點種類列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crMealTag',
        component: MealTagFormView,
        name: 'crMealTag',
        meta: {
          title: '新增餐點種類',
          description: '',
          route: '平台管理/餐點種類',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upMealTag/:tag_id',
        component: MealTagFormView,
        name: 'upMealTag',
        meta: {
          title: '編輯餐點種類',
          description: '',
          route: '平台管理/餐點種類',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crPlatformAd',
        component: PlatformCreateAdView,
        name: 'crPlatform',
        meta: {
          title: '新增平台廣告',
          description: '',
          route: '平台管理/平台廣告',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upPlatformAd/:ad_id',
        component: PlatformUpdatedAdView,
        name: 'upPlatformAd',
        meta: {
          title: '編輯平台廣告',
          description: '',
          route: '平台管理/平台廣告',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為品牌管理
        path: 'brandTable',
        component: BrandTableView,
        name: 'brandTable',
        meta: {
          title: '品牌管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'storeTable/:brand_id',
        component: StoreTableView,
        name: 'storeTable',
        meta: {
          title: '門市管理',
          description: '',
          route: '品牌管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'batchSetupStore/:brand_id',
        component: BatchSetupStore,
        name: 'batchSetupStore',
        meta: {
          title: '批次設定門市資訊',
          description: '',
          route: '批次設定門市資訊',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'groupTable/:brand_id',
        component: GroupTableView,
        name: 'groupTable',
        meta: {
          title: '群組管理',
          description: '',
          route: '品牌管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crBrand',
        component: CreateBrandView,
        name: 'crBrand',
        meta: {
          title: '新增品牌',
          description: '',
          route: '品牌管理',
          requiresAuth: true
        }
      }, {
        path: 'upBrand/:brand_id',
        component: UpdatedBrandView,
        name: 'upBrand',
        meta: {
          title: '編輯品牌',
          description: '',
          route: '品牌管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'brandInfo/:brand_id',
        component: BrandInfoView,
        name: 'brandInfo',
        meta: {
          title: '品牌資訊',
          description: '',
          route: '品牌管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'brandAdTable/:brand_id',
        component: BrandAdTableView,
        name: 'brandAdTable',
        meta: {
          title: '品牌廣告',
          description: '',
          route: '品牌管理',
          requiresAuth: true,
          isShowInJkos: true,
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/brandAdTable.pdf'
        }
      }, {
        path: 'crBrandAd/:brand_id',
        component: CreateBrandAdView,
        name: 'crBrandAd',
        meta: {
          title: '新增品牌廣告',
          description: '',
          route: '品牌管理/品牌廣告',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upBrandAd/:brand_id/:ad_id',
        component: UpdatedBrandAdView,
        name: 'upBrandAd',
        meta: {
          title: '編輯品牌廣告',
          description: '',
          route: '品牌管理/品牌廣告',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crStore/:brand_id',
        component: CreateStoreView,
        name: 'crStore',
        meta: {
          title: '新增門市',
          description: '',
          route: '品牌管理/門市管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crGroup/:brand_id',
        component: CreateGroupView,
        name: 'crGroup',
        meta: {
          title: '新增群組',
          description: '',
          route: '品牌管理/群組管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upStore/:brand_id/:store_id',
        component: UpdatedStoreView,
        name: 'upStore',
        meta: {
          title: '編輯單一門市資訊',
          description: '',
          route: '品牌管理/門市管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upGroup/:brand_id/:group_id',
        component: UpdatedGroupView,
        name: 'upGroup',
        meta: {
          title: '編輯群組',
          description: '',
          route: '品牌管理/門市管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'storeInfo/:brand_id/:store_id',
        component: StoreInfoView,
        name: 'storeInfo',
        meta: {
          title: '門市資訊',
          description: '',
          route: '品牌管理/門市管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'changeIcon/:brand_id',
        component: ChangeStoresIconView,
        name: 'changeIcon',
        meta: {
          title: '批次更換圖示',
          description: '',
          route: '品牌管理/門市管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'adTable/:brand_id/:store_id',
        component: AdTableView,
        name: 'adTable',
        meta: {
          title: '廣告管理',
          description: '',
          route: '品牌管理/門市管理',
          requiresAuth: true,
          isShowInJkos: true,
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/brandAdTable.pdf'
        }
      }, {
        path: 'crAd/:brand_id/:store_id',
        component: CreateAdView,
        name: 'crAd',
        meta: {
          title: '新增廣告',
          description: '',
          route: '品牌管理/門市管理/廣告管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upAd/:brand_id/:store_id/:ad_id',
        component: UpdatedAdView,
        name: 'upAd',
        meta: {
          title: '編輯廣告',
          description: '',
          route: '品牌管理/門市管理/廣告管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'copyAd/:brand_id/:store_id',
        component: CopyAdView,
        name: 'copyAd',
        meta: {
          title: '複製廣告',
          description: '',
          route: '品牌管理/門市管理/廣告管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, { // 以下為即時資料
        path: 'disItemTableOld',
        alias: '',
        component: DisItemTableOldView,
        name: 'disItemTableOld',
        meta: {
          title: '停賣管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為即時資料
        path: 'disItemTable',
        alias: '',
        component: DisItemTableView,
        name: 'disItemTable',
        meta: {
          title: '停賣管理',
          subTitle: '於菜單頁面停賣/解除停賣指定商品',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'disProduct/:brand_id/:menu_id',
        component: DisProductView,
        name: 'disProduct',
        meta: {
          title: '編輯多店停賣',
          description: '',
          route: '停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'reDisProduct/:brand_id/:menu_id',
        component: DisProductView,
        name: 'reDisProduct',
        meta: {
          title: '編輯多店解除停賣',
          description: '',
          route: '停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'disProduct/:brand_id/:menu_id/:store_id/forever',
        component: DisProductView,
        name: 'disProductStoreForever',
        meta: {
          title: '編輯永久停賣',
          description: '',
          route: '停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'disProduct/:brand_id/:menu_id/:store_id/daily',
        component: DisProductView,
        name: 'disProductStoreDaily',
        meta: {
          title: '編輯當日停賣',
          description: '',
          route: '停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'disItemScheduleTable',
        alias: '',
        component: DisScheduleItemTableView,
        name: 'disItemScheduleTable',
        meta: {
          title: '時段停賣管理',
          subTitle: '於指定的時間、日期、星期停賣/解除停賣指定商品',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false,
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/disItemScheduleTable.pdf'
        }
      }, {
        path: 'limitedItemScheduleTable',
        alias: '',
        component: LimitedScheduleItemTableView,
        name: 'limitedItemScheduleTable',
        meta: {
          title: '門市限時限量設定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false,
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/limitedItemScheduleTable.pdf'
        }
      }, {
        path: 'crDisableSchedule',
        alias: '',
        component: CrDisabeScheduleView,
        name: 'crDisableSchedule',
        meta: {
          title: '新增時段停賣',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crDisableScheduleItem',
        alias: '',
        component: CrDisabeScheduleView,
        name: 'crDisableScheduleItem',
        meta: {
          title: '新增時段停賣單一商品',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'copyLimiScheduleItem/:setting_id',
        alias: '',
        component: CopyLimiScheduleView,
        name: 'copyLimiScheduleItem',
        meta: {
          title: '複製門市限時限量設定',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crLimitScheduleItem',
        alias: '',
        component: CrLimitScheduleView,
        name: 'crLimitScheduleItem',
        meta: {
          title: '新增門市限時限量',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upLimitScheduleItem/:setting_id',
        alias: '',
        component: CrLimitScheduleView,
        name: 'upLimitScheduleItem',
        meta: {
          title: '編輯門市限時限量',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upDisableSchedule/:setting_id',
        alias: '',
        component: CrDisabeScheduleView,
        name: 'upDisableSchedule',
        meta: {
          title: '編輯時段停賣',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'disItemTable/:brand_id',
        alias: '',
        component: DisItemTableBrand,
        name: 'DisItemTableBrand',
        meta: {
          title: '批次記錄',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'disItemTable/:brand_id/:store_id',
        alias: '',
        component: DisItemTableStore,
        name: 'DisItemTableStore',
        meta: {
          title: '歷程記錄',
          description: '',
          route: '時段停賣管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'mqttTable',
        alias: '',
        component: MqttTableView,
        name: 'mqttTable',
        meta: {
          title: '連線管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'mqttSearch/:store_id',
        alias: '',
        component: MqttSearchView,
        name: 'mqttSearch',
        meta: {
          title: '單日連線紀錄',
          description: '',
          route: '連線管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'tableSetting',
        alias: '',
        component: TableSettingView,
        name: 'tableSetting',
        meta: {
          title: '座位管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'printerTable',
        alias: '',
        component: PrinterTableView,
        name: 'printerTable',
        meta: {
          title: '出單機管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'printerInfo/:printer_id',
        alias: '',
        component: PrinterInfoView,
        name: 'printerInfo',
        meta: {
          title: '出單機資訊',
          description: '',
          route: '出單機管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crPrinter',
        alias: '',
        component: CrPrinterView,
        name: 'crPrinter',
        meta: {
          title: '新增出單機',
          description: '',
          route: '出單機管理',
          requiresAuth: true
        }
      }, {
        path: 'upPrinter/:printer_id',
        alias: '',
        component: UpPrinterView,
        name: 'upPrinter',
        meta: {
          title: '編輯出單機',
          description: '',
          route: '出單機管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crPrinterStore/:printer_id',
        alias: '',
        component: CrPrinterStoreView,
        name: 'crPrinterStore',
        meta: {
          title: '新增店家綁定',
          description: '',
          route: '出單機管理/出單機資訊',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upPrinterStore/:printer_id/:binding_id',
        alias: '',
        component: UpPrinterStoreView,
        name: 'upPrinterStore',
        meta: {
          title: '編輯店家綁定',
          description: '',
          route: '出單機管理/出單機資訊',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'printerStore/:printer_id/:store_id',
        alias: '',
        component: PrinterStoreTableView,
        name: 'printerStore',
        meta: {
          title: '店家綁定列表',
          description: '',
          route: '出單機管理/出單機資訊',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為訂單管理
        path: 'orderTable',
        alias: '',
        component: OrderTableView,
        name: 'orderTable',
        meta: {
          title: '線上訂單管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為訂單管理
        path: 'onSiteOrderTable',
        alias: '',
        component: OrderTableView,
        name: 'onSiteOrderTable',
        meta: {
          title: '線下訂單管理',
          subTitle: '線下訂單會顯示消費者於門市現場消費並累積點數的資訊',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'onSiteOrderTable/member',
        alias: '',
        component: OrderTableView,
        name: 'onSiteOrderMemberTable',
        meta: {
          title: '線下訂單管理',
          subTitle: '線下訂單會顯示消費者於門市現場消費並累積點數的資訊',
          description: '',
          route: '會員單',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'onSiteOrderTable/guest',
        alias: '',
        component: OrderTableView,
        name: 'onSiteOrderGuestTable',
        meta: {
          title: '線下訂單管理',
          subTitle: '線下訂單會顯示消費者於門市現場消費並累積點數的資訊',
          description: '',
          route: '訪客單',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'orderExceptionTable',
        alias: '',
        component: OrderExceptionTableView,
        name: 'orderExceptionTable',
        meta: {
          title: '例外訂單管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'menuQuerystringView',
        alias: '',
        component: menuQuerystringView,
        name: 'menuQuerystringView',
        meta: {
          title: '追蹤碼',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'blackListTable',
        alias: '',
        component: BlackListView,
        name: 'blackListTable',
        meta: {
          title: '黑名單訂單管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'onSiteOrderTableInfo/:order_id',
        alias: '',
        component: OrderInfoView,
        name: 'onSiteOrderTableInfo',
        meta: {
          title: '訂單資訊',
          description: '',
          route: '訂單管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'orderInfo/:order_id',
        alias: '',
        component: OrderInfoView,
        name: 'orderInfo',
        meta: {
          title: '訂單資訊',
          description: '',
          route: '訂單管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      { // 以下為菜單管理
        path: 'menuTable',
        component: MenuTableView,
        name: 'menuTable',
        meta: {
          title: '菜單管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'menuDetailTable',
        component: MenuDetailTableView,
        name: 'menuDetailTable',
        meta: {
          title: '菜單管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true,
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf'
        }
      },
      {
        path: 'brandMenu/:brand_id',
        component: MenuStepView,
        name: 'brandMenu',
        meta: {
          title: '配料庫',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'crStoreClass/:brand_id',
        component: CrStoreClassView,
        name: 'crStoreClass',
        meta: {
          title: '門市群組',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'store-group/:brand_id',
        component: StoreGroup,
        name: 'storeGroup',
        meta: {
          title: '門市群組',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'storeTable/productImage/:brand_id',
        component: StoreMenuTable,
        name: 'storeTableProductImage',
        meta: {
          title: '圖片庫',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'storeTable/productSetting/:brand_id',
        component: StoreMenuTable,
        name: 'storeTableProductSetting',
        meta: {
          title: '別名/描述/警語',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'copy/productImage/:brand_id/:store_id',
        component: CopyStoreTemp,
        name: 'copyProductImage',
        meta: {
          title: '複製 門市圖片庫 至其他店家',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'copy/productSetting/:brand_id/:store_id',
        component: CopyStoreTemp,
        name: 'copyProductSetting',
        meta: {
          title: '複製 門市別名/描述/警語 至其他店家',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'storeTable/productImage/:brand_id/:store_id',
        component: ProductImageView,
        name: 'ProductImage',
        meta: {
          title: '圖片庫',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'storeTable/productSetting/:brand_id/:store_id',
        component: ProductSettingView,
        name: 'ProductSetting',
        meta: {
          title: '別名 / 描述 / 警語',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crProductSetting/:brand_id/:store_id',
        component: CrProductSettingView,
        name: 'crProductSetting',
        meta: {
          title: '新增門市別名/描述/警語',
          description: '',
          route: '門市別名/描述',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upProductAlias/:brand_id/:store_id/:setting_id',
        component: CrProductSettingView,
        name: 'upProductAlias',
        meta: {
          title: '更新別名',
          description: '',
          route: '門市別名/描述',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upProductDescription/:brand_id/:store_id/:setting_id',
        component: CrProductSettingView,
        name: 'upProductDescription',
        meta: {
          title: '更新描述/警語',
          description: '',
          route: '門市別名/描述',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'cupDiscountTable/:brand_id',
        component: CupDiscountTableView,
        name: 'cupDiscountTable',
        meta: {
          title: '自備飲料杯管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'cupDiscountTable/:brand_id/:store_id',
        component: CupDiscountTableView,
        name: 'cupDiscountTable',
        meta: {
          title: '自備飲料杯管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        path: 'crProductImg/:brand_id/:store_id',
        component: CrImgSettingView,
        name: 'crProductImg',
        meta: {
          title: '新增商品圖片',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crPackageImg/:brand_id/:store_id',
        component: CrImgSettingView,
        name: 'crPackageImg',
        meta: {
          title: '新增套餐圖片',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crCategoryImg/:brand_id/:store_id',
        component: CrImgSettingView,
        name: 'crCategoryImg',
        meta: {
          title: '新增商品分類圖片',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true
        }
      }, {
        path: 'upProductImg/:brand_id/:store_id/:setting_id',
        component: CrImgSettingView,
        name: 'upProductImg',
        meta: {
          title: '更新商品圖片',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upPackageImg/:brand_id/:store_id/:setting_id',
        component: CrImgSettingView,
        name: 'upPackageImg',
        meta: {
          title: '更新套餐圖片',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upCategoryImg/:brand_id/:store_id/:setting_id',
        component: CrImgSettingView,
        name: 'upCategoryImg',
        meta: {
          title: '更新商品分類圖片',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crProductIcon/:brand_id/:store_id',
        component: CrIconSettingView,
        name: 'crProductIcon',
        meta: {
          title: '新增菜單圖示',
          description: '',
          route: '門市圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upProductIcon/:brand_id/:store_id/:icon_id',
        component: CrIconSettingView,
        name: 'upProductIcon',
        meta: {
          title: '編輯菜單圖示',
          description: '',
          route: '品牌圖片庫',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'binding-pos/:brand_id',
        component: BindingPosView,
        name: 'BindingPos',
        meta: {
          title: '菜單綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crOptions/:brand_id',
        component: CrBindingView,
        name: 'crOptions',
        meta: {
          title: '配料綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crAdjusts/:brand_id',
        component: CrBindingView,
        name: 'crAdjusts',
        meta: {
          title: '配料群組綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crCategories/:brand_id',
        component: CrBindingView,
        name: 'crCategories',
        meta: {
          title: '商品分類綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crProducts/:brand_id',
        component: CrBindingView,
        name: 'crProducts',
        meta: {
          title: '商品綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crBlocks/:brand_id',
        component: CrBindingView,
        name: 'crBlocks',
        meta: {
          title: '品項選擇區綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crPackages/:brand_id',
        component: CrBindingView,
        name: 'crPackages',
        meta: {
          title: '套餐綁定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'brandMenuTable/:brand_id',
        component: MenuBuildView,
        name: 'brandMenuTable',
        meta: {
          title: '菜單建置',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crMenu/:brand_id',
        component: CreateMenuView,
        name: 'crMenu',
        meta: {
          title: '新增菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crProduct',
        component: CreateProductView,
        name: 'crProduct',
        meta: {
          title: '新增菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crOption',
        component: CreateOptionView,
        name: 'crOption',
        meta: {
          title: '新增菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crCombination',
        component: CreateCombinationView,
        name: 'crCombination',
        meta: {
          title: '新增菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'crJoinMenu',
        component: CreateJoinMenuView,
        name: 'crJoinMenu',
        meta: {
          title: '新增菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'menuInfo/:brand_id/:menu_id',
        component: MenuInfoView,
        name: 'menuInfo',
        meta: {
          title: '菜單資訊',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upMenu/:brand_id/:menu_id',
        component: UpdatedMenuView,
        name: 'upMenu',
        meta: {
          title: '編輯菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upProduct/:brand_id',
        component: UpdatedProductView,
        name: 'upProduct',
        meta: {
          title: '編輯菜單-商品',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upOption/:brand_id',
        component: UpMenuOptionView,
        name: 'upOption',
        meta: {
          title: '編輯菜單-配料',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upAdjust/:brand_id',
        component: UpMenuAdjustView,
        name: 'upAdjust',
        meta: {
          title: '編輯菜單-配料群組',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upCategory/:brand_id',
        component: UpdatedCategoryView,
        name: 'upCategory',
        meta: {
          title: '編輯菜單-商品分類',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upBlock/:brand_id',
        component: UpdatedBlockView,
        name: 'upBlock',
        meta: {
          title: '編輯菜單-選擇區',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upPackage/:brand_id',
        component: UpdatedPackageView,
        name: 'upPackage',
        meta: {
          title: '編輯菜單-套餐',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upCombination/:brand_id',
        component: UpdatedCombinationView,
        name: 'upCombination',
        meta: {
          title: '編輯菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upCombinationPrice/:brand_id',
        component: UpdatedCombinationPriceView,
        name: 'upCombinationPrice',
        meta: {
          title: '編輯菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upJoinMenu/:brand_id/:menu_id',
        component: UpdatedJoinMenuView,
        name: 'upJoinMenu',
        meta: {
          title: '編輯菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upJoinMenu/:brand_id/:menu_id/ok',
        component: UpdatedJoinMenuView,
        name: 'upJoinMenuOk',
        meta: {
          title: '編輯菜單',
          description: '',
          route: '菜單管理/品牌菜單管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, { // 以下為菜單排程管理
        path: 'scheduleTable',
        component: SeheduleTableView,
        name: 'scheduleTable',
        meta: {
          title: '菜單排程管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'brandScheduleTable/:brand_id',
        component: BrandScheduleTableView,
        name: 'brandScheduleTable',
        meta: {
          title: '排程管理',
          description: '',
          docLink: 'https://nidin-production.s3.ap-northeast-1.amazonaws.com/manual/ecms/menu.pdf',
          route: '菜單排程管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'storeScheduleTable/:brand_id/:store_id',
        component: StoreScheduleTableView,
        name: 'storeScheduleTable',
        meta: {
          title: '店家菜單排程管理',
          description: '',
          route: '菜單排程管理/品牌菜單排程管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'crSchedule/:brand_id/:menu_id',
        component: CrScheduleView,
        name: 'crSchedule',
        meta: {
          title: '新增排程',
          description: '',
          route: '菜單排程管理/品牌菜單排程管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      },
      {
        path: 'upSchedule/group/:brand_id/:group_id',
        component: UpScheduleView,
        name: 'upSchedule',
        meta: {
          title: '編輯排程',
          description: '',
          route: '菜單排程管理/品牌菜單排程管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, {
        path: 'upSchedule/:brand_id/:schedule_id',
        component: UpScheduleView,
        name: 'upStoreSchedule',
        meta: {
          title: '編輯排程',
          description: '',
          route: '菜單排程管理/品牌菜單排程管理',
          requiresAuth: true,
          isShowInJkos: true
        }
      }, { // 以下為活動管理
        path: 'couponTable',
        component: CouponListView,
        name: 'couponTable',
        meta: {
          title: '優惠券活動列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crActivity',
        component: CrActivityView,
        name: 'crActivity',
        meta: {
          title: '建立活動',
          description: '',
          route: '活動管理/優惠券活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crActivityInfoForm',
        component: ActivityInfoFormView,
        name: 'crActivityInfoForm',
        meta: {
          title: '建立活動資訊',
          description: '',
          route: '活動管理/優惠券活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upActivity/:activity_id',
        component: ActivityInfoFormView,
        name: 'upActivity',
        meta: {
          title: '編輯活動資訊',
          description: '',
          route: '活動管理/優惠券活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'activityInfo/:activity_id',
        component: ActivityInfoView,
        name: 'activityInfo',
        meta: {
          title: '活動資訊',
          description: '',
          route: '折扣活動列表',
          requiresAuth: true,
          isShowInJkos: false
        },
        children: [
          {
            path: 'detail',
            component: ActivityDetailView,
            name: 'activityDetail',
            meta: {
              title: '活動資訊'
            }
          }
        ]
      }, {
        path: 'upCouponTable',
        component: UpCouponTableView,
        name: 'upCouponTable',
        meta: {
          title: '編輯優惠券活動列表',
          description: '',
          route: '折扣活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為折扣管理
        path: 'discountTable',
        component: DiscountTableView,
        name: 'discountTable',
        meta: {
          title: '折扣活動列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false,
          docLink: 'https://drive.google.com/drive/folders/1tG0Y1dkD95QOP2Yw_5XEx6z2fkWp2Vzw'
        }
      }, {
        path: 'chooseDiscount',
        component: ChooseDiscountView,
        name: 'chooseDiscount',
        meta: {
          title: '選擇折扣活動方式',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false,
          docLink: 'https://drive.google.com/drive/folders/1tG0Y1dkD95QOP2Yw_5XEx6z2fkWp2Vzw'
        }
      }, {
        path: 'crDiscount',
        component: CrDiscountView,
        name: 'crDiscount',
        meta: {
          title: '新增折扣活動',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'upDiscountList',
        component: UpDiscountTableView,
        name: 'upDiscountList',
        meta: {
          title: '編輯折扣活動列表',
          description: '',
          route: '折扣活動列表',
          requiresAuth: true,
          isShowInJkos: false,
          docLink: 'https://drive.google.com/drive/folders/1tG0Y1dkD95QOP2Yw_5XEx6z2fkWp2Vzw'
        }
      }, {
        path: 'upDiscount/:activity_id',
        component: UpDiscountView,
        name: 'upDiscount',
        meta: {
          title: '編輯折扣活動',
          description: '',
          route: '折扣活動列表/編輯折扣活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'discountInfo/:activity_id',
        component: DiscountInfoView,
        name: 'discountInfo',
        meta: {
          title: '折扣活動資訊',
          description: '',
          route: '折扣活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'discountStore/:activity_id',
        component: DiscountStoreView,
        name: 'discountStore',
        meta: {
          title: '活動參與店家',
          description: '',
          route: '折扣活動列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為拆帳管理
        path: 'brandHistoryTable',
        component: BrandHistoryTableView,
        name: 'brandHistoryTable',
        meta: {
          title: '拆帳管理',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'storeHistoryTable/:brand_id',
        component: StoreHistoryTableView,
        name: 'storeHistoryTable',
        meta: {
          title: '門市管理',
          description: '',
          route: '拆帳管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'oneStoreHistoryTable/:brand_id/:store_id',
        component: OneStoreHistoryTableView,
        name: 'oneStoreHistoryTable',
        meta: {
          title: '店家拆帳列表管理',
          description: '',
          route: '拆帳管理/門市管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'oneDayHistoryTable/:brand_id/:store_id/:date',
        component: OneDayHistoryTableView,
        name: 'oneDayHistoryTable',
        meta: {
          title: '店家單日拆帳列表管理',
          description: '',
          route: '拆帳管理/門市管理/店家拆帳列表管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'oneDayHistory/:order_sn',
        component: OneDayHistoryTableView,
        name: 'oneDayHistory',
        meta: {
          title: '單筆拆帳訂單',
          description: '',
          route: '編號搜尋拆帳訂單',
          requiresAuth: true
        }
      }, {
        path: 'searchHistory',
        component: SearchHistoryView,
        name: 'searchHistory',
        meta: {
          title: '搜尋拆帳訂單',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'historyOrderInfo/:order_id',
        component: historyOrderInfoView,
        name: 'historyOrderInfo',
        meta: {
          title: '拆帳訂單資訊',
          description: '',
          route: '拆帳管理/門市管理/店家拆帳列表管理/店家單日拆帳列表管理',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為圖表統計
        path: 'chartDash',
        component: ChartDashView,
        name: 'chartDash',
        meta: {
          title: '月報表', // 圖表統計
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'weekChartDash',
        component: WeekChartDashView,
        name: 'weekChartDash',
        meta: {
          title: '週報表', // 圖表統計
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'searchMap',
        component: SearchMapView,
        name: 'searchMap',
        meta: {
          title: '搜尋區域',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'marketingChart',
        component: MarketingScheduleTableView,
        name: 'marketingChart',
        meta: {
          title: '行銷列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'couponChart/:promotion_id',
        component: CouponChartView,
        name: 'couponChart',
        meta: {
          title: '行銷報表',
          description: '',
          route: '行銷列表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'operatingChart',
        component: OperatingChart,
        name: 'operatingChart',
        meta: {
          title: '營運報表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'systemUsage',
        component: SystemUsage,
        name: 'systemUsage',
        meta: {
          title: '系統使用率報表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, { // 以下為對帳管理
        path: 'cashAccountTable',
        component: CashAccountView,
        name: 'cashAccountTable',
        meta: {
          title: '對帳紀錄表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'cashAccountErrorTable',
        component: CashAccountErrorView,
        name: 'cashAccountErrorTable',
        meta: {
          title: '對帳錯誤記錄表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'cashAccountInfo/:accounting_id',
        component: CashAccountInfoView,
        name: 'cashAccountInfo',
        meta: {
          title: '對帳資訊',
          description: '',
          route: '對帳紀錄表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'venderTradeTable',
        component: VenderTradeTable,
        name: 'venderTradeTable',
        meta: {
          title: '廠商對帳紀錄表',
          description: '',
          route: '廠商對帳紀錄表',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'cashAccountSearch',
        component: CashAccountSearchView,
        name: 'cashAccountSearch',
        meta: {
          title: '查詢對帳資訊',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'commissionHistory',
        component: CommissionHistory,
        name: 'commissionHistory',
        meta: {
          title: '抽成歷史報表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'commissionStore/:store_id',
        component: CommissionStore,
        name: 'commissionStore',
        meta: {
          title: '分店訂單列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        // 特約商店
        path: 'designatedTable',
        component: DesignatedTableView,
        name: 'designatedTable',
        meta: {
          title: '特約商店列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        path: 'crDesignated',
        component: CrDesignatedView,
        name: 'crDesignated',
        meta: {
          title: '新增特約商店',
          description: '',
          route: '',
          requiresAuth: true
        }
      }, {
        path: 'upDesignated/:brand_id/:unit_id',
        component: UpDesignatedView,
        name: 'upDesignated',
        meta: {
          title: '修改特約商店',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      }, {
        // 評價
        path: 'ratingTable',
        component: RatingTableView,
        name: 'ratingTable',
        meta: {
          title: '評價列表',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        // 公告
        path: 'announcement',
        component: announcement,
        name: 'announcement',
        meta: {
          title: '訊息公告',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        // 新增公告
        path: 'addAnnouncement',
        component: announcementForm,
        name: 'addAnnouncement',
        meta: {
          title: '新增公告訊息',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      {
        // 編輯公告
        path: 'editAnnouncement/:announcement_id',
        component: announcementForm,
        name: 'editAnnouncement',
        meta: {
          title: '編輯公告訊息',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      // 金流設定
      {
        path: 'trade-setting',
        component: TradeSetting,
        name: 'TradeSetting',
        meta: {
          title: '金流設定',
          description: '',
          route: '',
          requiresAuth: true,
          isShowInJkos: false
        }
      },
      // admin & brand to store
      ...brandToStoreMenu
      // End admin & brand to store
    ]
  }, {
    // not found handler
    path: '*',
    name: 'NotFound',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/index.js